export const FALLBACK_TIMEOUT = 30000; // 30sec
export const LOADING = 'loading';
export const SUCCESS = 'success';
export const FAILED = 'failed';
